<template>
  <div class="login-container d-flex align-items-center justify-content-center">
    <div class="card shadow-lg login-card">
      <div class="card-body p-5">
        <div class="text-center mb-4">
          <h2 class="fw-bold text-primary">Welcome Back</h2>
          <p class="text-muted">Please sign in to continue</p>
        </div>
        
        <form @submit.prevent="logIn">
          <div class="mb-4">
            <label for="emailInput" class="form-label fw-bold text-secondary small text-uppercase">Email Address</label>
            <input 
              type="email" 
              class="form-control form-control-lg" 
              name="email" 
              v-model="input.email" 
              id="emailInput" 
              placeholder="name@example.com" 
              autocomplete="email"
            >
          </div>
          <div class="mb-4">
            <label for="passwordInput" class="form-label fw-bold text-secondary small text-uppercase">Password</label>
            <input 
              type="password" 
              class="form-control form-control-lg" 
              name="password" 
              v-model="input.password" 
              id="passwordInput" 
              placeholder="••••••••"
              v-on:keyup.enter="logIn"
            >
          </div>
          <div class="d-grid gap-2">
            <button type="submit" class="btn btn-primary btn-lg shadow-sm" @click="logIn">
              Sign In
            </button>
          </div>
        </form>
      </div>        
    </div>
  </div>
</template>

<script>
import { userRef, db, authnya } from '../firebase.js'
import { getUA } from '../deviceAPI.js'

export default {
  name: 'TheLogin',
  firebase: {
      mahasiswa: userRef
    },
  data() {
      return {
          input: {
              email: "family@afrizalmy.com",
              password: ""
          }
      }
  },
  methods: {
    logIn() {
        if (this.input.email != "" && this.input.password != "") {    
            authnya.signInWithEmailAndPassword(this.input.email, this.input.password)
            .then(data => {
                this.$router.replace({ name: "Home" });
            })
            .catch(error => {
                Swal.fire({
                        title: 'Gagal Login!',
                        text: error.message,
                        icon: 'error',
                        confirmButtonText: 'Oke'
                    })
                console.log(error.message);
            })
        } else {
            Swal.fire({
                title: 'Error!',
                text: 'Isian Masih Kosong !!',
                icon: 'info',
                confirmButtonText: 'Oke'
            })
        }
    }
  }
}
</script>

<style scoped>

.login-container {

  min-height: 100vh;

  background: var(--bg-body);

  transition: background-color 0.3s ease;

}



.login-card {

  width: 100%;

  max-width: 450px;

  border-radius: 20px;

  background-color: var(--card-bg);

  color: var(--text-main);

}



h2 { color: var(--text-main); }

p.text-muted { color: var(--text-muted) !important; }

label { color: var(--text-muted); }

</style>
